var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":-1,"hide-default-footer":"","dense":""},scopedSlots:_vm._u([{key:`item.actions`,fn:function({ item }){return [_c('v-icon',{on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v(" mdi-delete ")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }